import { ApiRoutes, QueryError } from '../../../common/interfaces';
import { apiExecutor, buildMutation, buildQuery } from '../../../common/services';
import { HostingAccount } from '../entities';
import { HostingAccountFormFields } from '../hostings.interfaces';
import { HostingAccountsQueryKeys } from './hostings.keys';

export const useGetPasswordForHostingAccountsMutation = (hostingId: string, hostingAccountId: string) =>
  buildQuery<Pick<HostingAccount, 'password'>, QueryError>(
    [HostingAccountsQueryKeys.ShowPassword, hostingId, hostingAccountId],
    async () => {
      const { data } = await apiExecutor.get<Pick<HostingAccount, 'password'>>(
        ApiRoutes.HostingAccountsByIdPassword.replace(':hostingId', hostingId).replace(':hostingAccountId', hostingAccountId),
      );
      return data;
    },
  );

export const useGetAllHostingAccountsQuery = (hostingId: string) =>
  buildQuery<HostingAccount[], QueryError>([HostingAccountsQueryKeys.GetAll, hostingId], async () => {
    const { data } = await apiExecutor.get<HostingAccount[]>(ApiRoutes.HostingsByIdAccounts.replace(':hostingId', hostingId));
    return data;
  });

export const useCreateHostingAccountsMutation = (hostingId: string) =>
  buildMutation<HostingAccount, QueryError, HostingAccountFormFields>(
    [HostingAccountsQueryKeys.Create, hostingId],
    async (postData) => {
      const { data } = await apiExecutor.post<HostingAccount>(ApiRoutes.HostingsByIdAccounts.replace(':hostingId', hostingId), {
        ...postData,
        hostingId,
      });
      return data;
    },
  );

export const useEditHostingAccountsMutation = (hostingId: string) =>
  buildMutation<HostingAccount, QueryError, HostingAccountFormFields>(
    [HostingAccountsQueryKeys.Edit, hostingId],
    async (postData) => {
      const { data } = await apiExecutor.post<HostingAccount>(ApiRoutes.HostingsByIdAccounts.replace(':hostingId', hostingId), {
        ...postData,
        hostingId,
      });
      return data;
    },
  );

export const useDeleteHostingAccountsMutation = (hostingId: string) =>
  buildMutation<void, QueryError, string>([HostingAccountsQueryKeys.Delete, hostingId], async (id) => {
    const { data } = await apiExecutor.delete<void>(
      ApiRoutes.HostingAccountsById.replace(':hostingId', hostingId).replace(':hostingAccountId', id),
    );
    return data;
  });

export const useAutocompleteHostingAccountsMutation = () =>
  buildMutation<Pick<HostingAccount, 'id' | 'login'>[], QueryError, string>(
    [HostingAccountsQueryKeys.Autocomplete],
    async (hostingId) => {
      const { data } = await apiExecutor.get<Pick<HostingAccount, 'id' | 'login'>[]>(
        ApiRoutes.HostingsByIdAccountsAutocomplete.replace(':hostingId', hostingId),
      );
      return data;
    },
  );
